import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.home.hero.eyebrow": "Dizaynerlar yaratgan premium taklifnomalar",
    "tk.home.hero.eyebrow_short": "Premium onlayn taklifnomalar",
    "tk.home.hero.title_a": "Tantanangiz",
    "tk.home.hero.title_em": "taklifnomadan",
    "tk.home.hero.title_b": "boshlanadi",
    "tk.home.hero.lead": "To'y, nikoh, tug'ilgan kun va boshqa bayramlar uchun. Ismlar va sanani kiriting, havolani Telegram orqali yuboring — mehmonlar javobi bir joyda jamlanadi.",
    "tk.home.cta.choose": "Shablon tanlash",
    "tk.home.cta.demo": "Jonli namunani ko'rish",
    "tk.home.trust.devices": "Telefon va kompyuterda ochiladi",
    "tk.home.trust.noapp": "Ilova o'rnatish shart emas",
    "tk.home.trust.langs": "O'zbek, rus va ingliz tillarida",

    "tk.home.templates.title_a": "Har bir tantana uchun",
    "tk.home.templates.title_em": "o'z dizayni",
    "tk.home.templates.lead": "Har bir shablonni dizaynerlarimiz noldan chizgan. Yoqqanini tanlang — ismlar, sana va manzil sizniki bo'ladi.",
    "tk.home.templates.all": "Barcha {n} shablonni ko'rish",

    "tk.home.how.title_a": "Uch qadam —",
    "tk.home.how.title_em": "taklifnoma tayyor",
    "tk.home.how.lead": "Bir necha daqiqa kifoya — telefondan ham, kompyuterdan ham birdek qulay.",
    "tk.home.how.step": "{n}-qadam",
    "tk.home.how.s1.title": "Shablonni tanlang",
    "tk.home.how.s1.text": "Tadbiringizga mos dizaynni tanlang va u telefonda qanday ko'rinishini oldindan ko'ring.",
    "tk.home.how.s2.title": "Ma'lumotlarni kiriting",
    "tk.home.how.s2.text": "Ismlar, sana, vaqt va manzil. Har bir o'zgarish taklifnomada darhol ko'rinadi.",
    "tk.home.how.s3.title": "Havolani yuboring",
    "tk.home.how.s3.text": "To'lovdan so'ng shaxsiy havola tayyor. Uni Telegram, WhatsApp yoki Instagram orqali ulashing.",
    "tk.home.how.art.send": "Telegram orqali yuborish",
    "tk.home.how.art.replied": "javob berdi",

    "tk.home.features.eyebrow": "Imkoniyatlar",
    "tk.home.features.title_a": "Mehmonlar uchun",
    "tk.home.features.title_em": "hammasi bir sahifada",
    "tk.home.features.lead": "Imkoniyatlar shablonga qarab farq qiladi va barchasi narxga kiritilgan — qo'shimcha to'lov yo'q.",
    "tk.home.features.link.title": "Shaxsiy havola",
    "tk.home.features.link.text": "Ismlaringiz yozilgan chiroyli manzil",
    "tk.home.features.link.short": "Ismlaringiz yozilgan manzil",
    "tk.home.features.rsvp.title": "Javob tugmasi",
    "tk.home.features.rsvp.text": "Mehmon bir bosishda «Kelaman» yoki «Kela olmayman» deydi",
    "tk.home.features.rsvp.short": "Bir bosishda «Kelaman»",
    "tk.home.features.countdown.title": "Orqaga sanoq",
    "tk.home.features.countdown.text": "Tantanagacha qolgan kun, soat va daqiqalar",
    "tk.home.features.countdown.short": "Tantanagacha qolgan vaqt",
    "tk.home.features.map.title": "Xarita",
    "tk.home.features.map.text": "Google yoki Yandex xaritasi orqali manzilgacha yo'l",
    "tk.home.features.map.short": "Google va Yandex",
    "tk.home.features.music.title": "Musiqa",
    "tk.home.features.music.text": "Taklifnoma uchun fon kuyini o'zingiz tanlaysiz",
    "tk.home.features.music.short": "Yoqimli fon kuyi",
    "tk.home.features.photos.title": "Suratlar",
    "tk.home.features.photos.text": "Eng sevimli suratlaringiz uchun albom",
    "tk.home.features.photos.short": "Sevimli suratlar albomi",
    "tk.home.features.wishes.title": "Tilaklar devori",
    "tk.home.features.wishes.text": "Mehmonlar tabrik va tilaklarini qoldiradi",
    "tk.home.features.wishes.short": "Mehmonlar tabriklari",
    "tk.home.features.qr.title": "QR kod",
    "tk.home.features.qr.text": "Chop etish uchun tayyor QR kod",
    "tk.home.features.qr.short": "Chop etishga tayyor",

    "tk.home.cabinet.title_a": "Kim keladi —",
    "tk.home.cabinet.title_em": "bir qarashda",
    "tk.home.cabinet.lead": "Mehmonlar javobi va tilaklari kabinetingizda jamlanadi: kim keladi, kim kela olmaydi va kim qanday tilak yozdi.",
    "tk.home.cabinet.c1": "Keladiganlar va kelmaydiganlar avtomatik sanaladi",
    "tk.home.cabinet.c2": "Mehmonlar javoblari bitta ro'yxatda",
    "tk.home.cabinet.c3": "Tilaklarni o'qiysiz, keraksizini o'chirasiz",
    "tk.home.cabinet.cta": "Kabinetni ko'rish",
    "tk.home.demo.stat_yes": "Keladi",
    "tk.home.demo.stat_no": "Kelmaydi",
    "tk.home.demo.stat_total": "Jami javoblar",
    "tk.home.demo.share": "javoblarning {n}%",
    "tk.home.demo.maybe": "Balki: {n}",
    "tk.home.demo.responses": "Javoblar",
    "tk.home.demo.badge_yes": "Keladi",
    "tk.home.demo.badge_no": "Kelmaydi",
    "tk.home.demo.g1.name": "Madina Karimova",
    "tk.home.demo.g2.name": "Bobur Rashidov",
    "tk.home.demo.g3.name": "Iroda Yo'ldosheva",
    "tk.home.demo.g4.name": "Sherzod Ahmedov",

    "tk.home.pricing.title_a": "Bir marta to'laysiz.",
    "tk.home.pricing.title_em": "Obuna yo'q.",
    "tk.home.pricing.per": "Har bir taklifnoma",
    "tk.home.pricing.from": "Boshlang'ich narx",
    "tk.home.pricing.once": "Bir martalik to'lov — shablonni tanlaganingizda",
    "tk.home.pricing.i1": "Shaxsiy havola va QR kod",
    "tk.home.pricing.i2": "Cheksiz mehmonlar",
    "tk.home.pricing.i3": "Javoblar va tilaklar kabineti",
    "tk.home.pricing.i4": "Nashrdan keyin ham tahrirlash",
    "tk.home.pricing.i5": "Telegram va WhatsApp orqali ulashish",
    "tk.home.pricing.methods": "Payme · Uzcard · Humo",
    "tk.home.pricing.methods_intl": "Karta orqali xavfsiz to'lov",

    "tk.home.faq.lead": "Javob topmadingizmi? Telegram orqali yozing — yordam beramiz.",
    "tk.home.faq.open.q": "Mehmonlar taklifnomani qanday ochadi?",
    "tk.home.faq.open.a": "Havolani bosishadi, xolos — ilova o'rnatish shart emas. Taklifnoma telefon va kompyuterda birdek chiroyli ochiladi.",
    "tk.home.faq.pay.q": "Qanday to'lov usullari bor?",
    "tk.home.faq.pay.a": "Payme orqali — Uzcard yoki Humo kartasi bilan. To'lov bir marta amalga oshiriladi, obuna yo'q.",
    "tk.home.faq.pay.a_intl": "Bank kartasi orqali, xavfsiz to'lov sahifasida. To'lov bir marta amalga oshiriladi, obuna yo'q.",

    "tk.home.final.title_a": "Mehmonlaringizni",
    "tk.home.final.title_em": "chiroyli",
    "tk.home.final.title_b": "taklif qiling",
    "tk.home.final.lead": "Shablonni tanlang — taklifnoma bir necha daqiqada tayyor bo'ladi.",
  },
  ru: {
    "tk.home.hero.eyebrow": "Премиальные приглашения от дизайнеров",
    "tk.home.hero.eyebrow_short": "Премиальные онлайн-приглашения",
    "tk.home.hero.title_a": "Торжество",
    "tk.home.hero.title_em": "начинается",
    "tk.home.hero.title_b": "с приглашения",
    "tk.home.hero.lead": "Для свадьбы, никаха, дня рождения и других праздников. Введите имена и дату, отправьте ссылку в Telegram — ответы гостей соберутся в одном месте.",
    "tk.home.cta.choose": "Выбрать шаблон",
    "tk.home.cta.demo": "Смотреть живой пример",
    "tk.home.trust.devices": "Открывается на телефоне и компьютере",
    "tk.home.trust.noapp": "Не нужно устанавливать приложение",
    "tk.home.trust.langs": "На узбекском, русском и английском",

    "tk.home.templates.title_a": "Для каждого торжества —",
    "tk.home.templates.title_em": "свой дизайн",
    "tk.home.templates.lead": "Каждый шаблон наши дизайнеры нарисовали с нуля. Выберите понравившийся — имена, дата и место будут вашими.",
    "tk.home.templates.all": "Смотреть все шаблоны ({n})",

    "tk.home.how.title_a": "Три шага —",
    "tk.home.how.title_em": "и приглашение готово",
    "tk.home.how.lead": "Хватит нескольких минут — одинаково удобно с телефона и с компьютера.",
    "tk.home.how.step": "Шаг {n}",
    "tk.home.how.s1.title": "Выберите шаблон",
    "tk.home.how.s1.text": "Подберите дизайн под ваше событие и заранее посмотрите, как он выглядит на телефоне.",
    "tk.home.how.s2.title": "Заполните данные",
    "tk.home.how.s2.text": "Имена, дата, время и место. Каждое изменение сразу видно в приглашении.",
    "tk.home.how.s3.title": "Отправьте ссылку",
    "tk.home.how.s3.text": "После оплаты личная ссылка готова. Поделитесь ею в Telegram, WhatsApp или Instagram.",
    "tk.home.how.art.send": "Отправить в Telegram",
    "tk.home.how.art.replied": "ответила",

    "tk.home.features.eyebrow": "Возможности",
    "tk.home.features.title_a": "Для гостей —",
    "tk.home.features.title_em": "всё на одной странице",
    "tk.home.features.lead": "Набор возможностей зависит от шаблона, и всё уже входит в цену — без доплат.",
    "tk.home.features.link.title": "Личная ссылка",
    "tk.home.features.link.text": "Красивый адрес с вашими именами",
    "tk.home.features.link.short": "Адрес с вашими именами",
    "tk.home.features.rsvp.title": "Кнопка ответа",
    "tk.home.features.rsvp.text": "Гость отвечает «Приду» или «Не смогу» в одно касание",
    "tk.home.features.rsvp.short": "«Приду» в одно касание",
    "tk.home.features.countdown.title": "Обратный отсчёт",
    "tk.home.features.countdown.text": "Дни, часы и минуты до торжества",
    "tk.home.features.countdown.short": "Время до торжества",
    "tk.home.features.map.title": "Карта",
    "tk.home.features.map.text": "Маршрут до места через Google или Яндекс Карты",
    "tk.home.features.map.short": "Google и Яндекс",
    "tk.home.features.music.title": "Музыка",
    "tk.home.features.music.text": "Фоновую мелодию вы выбираете сами",
    "tk.home.features.music.short": "Приятная фоновая мелодия",
    "tk.home.features.photos.title": "Фотографии",
    "tk.home.features.photos.text": "Альбом для ваших любимых снимков",
    "tk.home.features.photos.short": "Альбом любимых фото",
    "tk.home.features.wishes.title": "Стена пожеланий",
    "tk.home.features.wishes.text": "Гости оставляют поздравления и пожелания",
    "tk.home.features.wishes.short": "Поздравления гостей",
    "tk.home.features.qr.title": "QR-код",
    "tk.home.features.qr.text": "Готовый QR-код для печати",
    "tk.home.features.qr.short": "Готов к печати",

    "tk.home.cabinet.title_a": "Кто придёт —",
    "tk.home.cabinet.title_em": "видно сразу",
    "tk.home.cabinet.lead": "Ответы и пожелания гостей собираются в вашем кабинете: кто придёт, кто не сможет и кто что пожелал.",
    "tk.home.cabinet.c1": "Сколько гостей придёт, а сколько нет — считается автоматически",
    "tk.home.cabinet.c2": "Ответы гостей — в одном списке",
    "tk.home.cabinet.c3": "Читайте пожелания и удаляйте лишние",
    "tk.home.cabinet.cta": "Открыть кабинет",
    "tk.home.demo.stat_yes": "Придут",
    "tk.home.demo.stat_no": "Не придут",
    "tk.home.demo.stat_total": "Всего ответов",
    "tk.home.demo.share": "{n}% ответов",
    "tk.home.demo.maybe": "Возможно: {n}",
    "tk.home.demo.responses": "Ответы",
    "tk.home.demo.badge_yes": "Придёт",
    "tk.home.demo.badge_no": "Не придёт",
    "tk.home.demo.g1.name": "Мадина Каримова",
    "tk.home.demo.g2.name": "Бобур Рашидов",
    "tk.home.demo.g3.name": "Ирода Юлдашева",
    "tk.home.demo.g4.name": "Шерзод Ахмедов",

    "tk.home.pricing.title_a": "Платите один раз.",
    "tk.home.pricing.title_em": "Без подписки.",
    "tk.home.pricing.per": "За одно приглашение",
    "tk.home.pricing.from": "Цена от",
    "tk.home.pricing.once": "Разовый платёж — при выборе шаблона",
    "tk.home.pricing.i1": "Личная ссылка и QR-код",
    "tk.home.pricing.i2": "Без ограничения числа гостей",
    "tk.home.pricing.i3": "Кабинет с ответами и пожеланиями",
    "tk.home.pricing.i4": "Можно править и после публикации",
    "tk.home.pricing.i5": "Отправка через Telegram и WhatsApp",
    "tk.home.pricing.methods": "Payme · Uzcard · Humo",
    "tk.home.pricing.methods_intl": "Безопасная оплата картой",

    "tk.home.faq.lead": "Не нашли ответ? Напишите нам в Telegram — поможем.",
    "tk.home.faq.open.q": "Как гости откроют приглашение?",
    "tk.home.faq.open.a": "Просто перейдут по ссылке — устанавливать ничего не нужно. Приглашение одинаково красиво открывается на телефоне и на компьютере.",
    "tk.home.faq.pay.q": "Какие есть способы оплаты?",
    "tk.home.faq.pay.a": "Через Payme — картой Uzcard или Humo. Платёж разовый, без подписки.",
    "tk.home.faq.pay.a_intl": "Банковской картой на защищённой странице оплаты. Платёж разовый, без подписки.",

    "tk.home.final.title_a": "Пригласите гостей",
    "tk.home.final.title_em": "красиво",
    "tk.home.final.title_b": "",
    "tk.home.final.lead": "Выберите шаблон — приглашение будет готово за несколько минут.",
  },
  en: {
    "tk.home.hero.eyebrow": "Premium invitations crafted by designers",
    "tk.home.hero.eyebrow_short": "Premium online invitations",
    "tk.home.hero.title_a": "Your celebration",
    "tk.home.hero.title_em": "begins",
    "tk.home.hero.title_b": "with an invitation",
    "tk.home.hero.lead": "For weddings, nikoh, birthdays and every other celebration. Add the names and date, share the link — every guest reply lands in one place.",
    "tk.home.cta.choose": "Choose a template",
    "tk.home.cta.demo": "See a live example",
    "tk.home.trust.devices": "Opens on any phone or computer",
    "tk.home.trust.noapp": "No app to install",
    "tk.home.trust.langs": "In English, Uzbek and Russian",

    "tk.home.templates.title_a": "For every celebration,",
    "tk.home.templates.title_em": "its own design",
    "tk.home.templates.lead": "Our designers drew every template from scratch. Pick the one you love — the names, date and venue become yours.",
    "tk.home.templates.all": "See all {n} templates",

    "tk.home.how.title_a": "Three steps —",
    "tk.home.how.title_em": "and it's ready",
    "tk.home.how.lead": "A few minutes is all it takes — just as easy on a phone as on a computer.",
    "tk.home.how.step": "Step {n}",
    "tk.home.how.s1.title": "Choose a template",
    "tk.home.how.s1.text": "Find a design that fits your event and preview exactly how it looks on a phone.",
    "tk.home.how.s2.title": "Add your details",
    "tk.home.how.s2.text": "Names, date, time and venue. Every change shows up in the invitation instantly.",
    "tk.home.how.s3.title": "Send the link",
    "tk.home.how.s3.text": "Your personal link is ready right after payment. Share it on Telegram, WhatsApp or Instagram.",
    "tk.home.how.art.send": "Send via Telegram",
    "tk.home.how.art.replied": "replied",

    "tk.home.features.eyebrow": "Features",
    "tk.home.features.title_a": "For your guests,",
    "tk.home.features.title_em": "everything on one page",
    "tk.home.features.lead": "Features vary by template, and all of them are included in the price — no extras to pay for.",
    "tk.home.features.link.title": "Personal link",
    "tk.home.features.link.text": "A beautiful address with your names in it",
    "tk.home.features.link.short": "An address with your names",
    "tk.home.features.rsvp.title": "Reply button",
    "tk.home.features.rsvp.text": "Guests answer “I'll be there” or “Can't make it” in one tap",
    "tk.home.features.rsvp.short": "“I'll be there” in one tap",
    "tk.home.features.countdown.title": "Countdown",
    "tk.home.features.countdown.text": "Days, hours and minutes until the big day",
    "tk.home.features.countdown.short": "Time left to the big day",
    "tk.home.features.map.title": "Map",
    "tk.home.features.map.text": "Directions to the venue via Google or Yandex Maps",
    "tk.home.features.map.short": "Google and Yandex",
    "tk.home.features.music.title": "Music",
    "tk.home.features.music.text": "Background music of your choice",
    "tk.home.features.music.short": "Gentle background music",
    "tk.home.features.photos.title": "Photos",
    "tk.home.features.photos.text": "An album for your favourite photos",
    "tk.home.features.photos.short": "An album of favourite photos",
    "tk.home.features.wishes.title": "Wishes wall",
    "tk.home.features.wishes.text": "Guests leave their congratulations and wishes",
    "tk.home.features.wishes.short": "Your guests' congratulations",
    "tk.home.features.qr.title": "QR code",
    "tk.home.features.qr.text": "A print-ready QR code",
    "tk.home.features.qr.short": "Ready to print",

    "tk.home.cabinet.title_a": "Who's coming,",
    "tk.home.cabinet.title_em": "at a glance",
    "tk.home.cabinet.lead": "Your guests' replies and wishes gather in your dashboard: who's coming, who can't make it, and what everyone wished you.",
    "tk.home.cabinet.c1": "Yes and no replies are counted automatically",
    "tk.home.cabinet.c2": "Guest replies in one list",
    "tk.home.cabinet.c3": "Read every wish and remove the ones you don't want",
    "tk.home.cabinet.cta": "Open your dashboard",
    "tk.home.demo.stat_yes": "Attending",
    "tk.home.demo.stat_no": "Not attending",
    "tk.home.demo.stat_total": "Total responses",
    "tk.home.demo.share": "{n}% of responses",
    "tk.home.demo.maybe": "Maybe: {n}",
    "tk.home.demo.responses": "Responses",
    "tk.home.demo.badge_yes": "Attending",
    "tk.home.demo.badge_no": "Not attending",
    "tk.home.demo.g1.name": "Emma Wilson",
    "tk.home.demo.g2.name": "James Carter",
    "tk.home.demo.g3.name": "Olivia Brown",
    "tk.home.demo.g4.name": "Henry Adams",

    "tk.home.pricing.title_a": "Pay once.",
    "tk.home.pricing.title_em": "No subscription.",
    "tk.home.pricing.per": "Per invitation",
    "tk.home.pricing.from": "Starting from",
    "tk.home.pricing.once": "One-time payment when you choose a template",
    "tk.home.pricing.i1": "Personal link and QR code",
    "tk.home.pricing.i2": "Unlimited guests",
    "tk.home.pricing.i3": "A dashboard for replies and wishes",
    "tk.home.pricing.i4": "Edit even after publishing",
    "tk.home.pricing.i5": "Share via Telegram and WhatsApp",
    "tk.home.pricing.methods": "Payme · Uzcard · Humo",
    "tk.home.pricing.methods_intl": "Secure card payment",

    "tk.home.faq.lead": "Didn't find your answer? Message us on Telegram — we're happy to help.",
    "tk.home.faq.open.q": "How do guests open the invitation?",
    "tk.home.faq.open.a": "They simply tap the link — there's nothing to install. The invitation looks just as beautiful on a phone as on a computer.",
    "tk.home.faq.pay.q": "How can I pay?",
    "tk.home.faq.pay.a": "Via Payme, with an Uzcard or Humo card. It's a one-time payment — no subscription.",
    "tk.home.faq.pay.a_intl": "By bank card on a secure checkout page. It's a one-time payment — no subscription.",

    "tk.home.final.title_a": "Invite your guests",
    "tk.home.final.title_em": "beautifully",
    "tk.home.final.title_b": "",
    "tk.home.final.lead": "Pick a template — your invitation is ready in minutes.",
  },
};

export default dict;
